import React from 'react';
import PageTemplate from '../../../components/template/PageTemplate';
import AccountUserDetailContainer from '../../../containers/account/user/AccountUserDetailContainer';
import { ACCOUNT_USER_PAGE_NAME } from '../../../constants/service/app/accountUserConstants';

const AccountUserDetail = () => {
  return (
    <PageTemplate pageName={ACCOUNT_USER_PAGE_NAME.USER_DETAIL}>
      <AccountUserDetailContainer />
    </PageTemplate>
  );
};

export default AccountUserDetail;
